"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const spin = styled_components_1.keyframes `
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;
const Circle = styled_components_1.default.div `
  width: ${(props) => props.size};
  height: ${(props) => props.size};
  border: 3px transparent solid;
  border-radius: 50%;
  border-top-color: ${(props) => props.theme.colors.primaryAccent};
  border-left-color: ${(props) => props.theme.colors.primaryAccent};
  ${(props) => (props.inline ? `display: inline-block;` : ``)}

  animation: ${spin} ${(props) => props.speed}ms linear infinite;
`;
const SpinnerIcon = ({ size = '18px', inline = false, speed = 500, className = '', }) => (react_1.default.createElement(Circle, { size: size, inline: inline, speed: speed, className: className }));
exports.default = SpinnerIcon;
